import { render, staticRenderFns } from "./ShuttleDayDetails.vue?vue&type=template&id=6c8769b0&scoped=true&"
import script from "./ShuttleDayDetails.vue?vue&type=script&lang=js&"
export * from "./ShuttleDayDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleDayDetails.vue?vue&type=style&index=0&id=6c8769b0&lang=scss&scoped=true&"
import style1 from "./ShuttleDayDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8769b0",
  null
  
)

export default component.exports